jQuery(document).ready( function($) {
    $( ".img-popout" ).each(function() {
        let link = $(this).find("img").attr("src");
        $(this).find("img").wrap("<a href='" + link + "' class='magnific-img'></a>");
    });

    $('.magnific-img').magnificPopup({
      type: 'image'
    });
});
